// Mobile nav drawer toggle — used by sections/fresh-header.liquid
document.addEventListener('DOMContentLoaded', function () {
  var burger = document.getElementById('freshBurgerBtn');
  var mainNav = document.getElementById('freshMainNav');
  if (!burger || !mainNav) return;

  burger.addEventListener('click', function () {
    var isOpen = mainNav.classList.toggle('open');
    burger.setAttribute('aria-expanded', isOpen);
  });
});
